import React from 'react';
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';
import { cn } from '@/lib/utils';

const statusOptions = [
  { value: 1, label: '在线', color: '#43E453' },
  { value: 2, label: '隐身', color: '#B3B3B3' },
];

interface StatusSwitcherProps {
  value: number;
  onChange: (value: number) => void;
  className?: string;
}

const StatusSwitcher: React.FC<StatusSwitcherProps> = ({ value, onChange, className }) => {
  return (
    <ToggleGroup
      type="single"
      value={value?.toString()}
      onValueChange={(value: string) => onChange(Number(value))}
      className={cn('flex items-center', className)}
    >
      {statusOptions.map((opt) => (
        <ToggleGroupItem className="gap-sm flex-1" key={opt.value} value={opt.value?.toString()}>
          <span
            style={{
              width: 12,
              height: 12,
              borderRadius: '50%',
              background: opt.color,
              border: '2px solid #fff',
              boxSizing: 'border-box',
              display: 'block',
              boxShadow: '0px 0px 1px 0px rgba(0, 0, 0, 0.10)',
            }}
          />
          <span>{opt.label}</span>
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  );
};

export default StatusSwitcher;
